




























































import AffirmationFilterModel from "@models/affirmations/affirmationFilterModel";
import { Vue, Component, Inject } from "vue-property-decorator";
import { AFFIRMATION_CREATE, AFFIRMATION_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import AffirmationGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetListResponse";
import { DragLiModel } from "@components/ui/models";
import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class PageAffirmationComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: AffirmationFilterModel = new AffirmationFilterModel();
  columnNames = ["#", "Картинка", "Название", "Платная", "Дата", "", ""];
  createRouteName = AFFIRMATION_CREATE;
  editRouteName = AFFIRMATION_EDIT;
  getDataFunc = this.$api.AffirmationService.getListAsync.bind(
    this.$api.AffirmationService
  );
  removeFunc = this.$api.AffirmationService.deleteAsync.bind(
    this.$api.AffirmationService
  );

  async created() {}

  async startDelete(item: AffirmationGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.AffirmationService.getListAsync(
        new SearchFilterRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  Image: x.CoverUrl,
                  SortIndex: index + 1,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: t.Name,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.AffirmationService.changeSortIndexAsync(
        new ChangeSortIndexRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexRequest({
                Id: Number(x.Id),
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
